// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eXRT","messages":"styles_messages__2ZIey"};